import { AuditEntityType, LegalEntityOurDataDto, LegalEntityOurDataCreateDto, LegalEntityOurDataUpdateDto } from '@sr/dto';
import { legalEntitiesApi } from '../legal-entities.api';
import { LEGAL_ENTITY_BASE_URL } from 'shared/api/api';
import { invalidateEntityAudit } from 'entities/audit/utils';

type LegalEntityLink = {
  legalEntityId: number;
};

export const ourLegalEntitiesApi = legalEntitiesApi.injectEndpoints({
  endpoints: (builder) => ({
    getOurLegalEntityData: builder.query<LegalEntityOurDataDto, number>({
      query: (legalEntityId) => ({
        url: `${LEGAL_ENTITY_BASE_URL}/our-legal-entity-data/${legalEntityId}`
      }),
      providesTags: (result, error, legalEntityId) => [{ type: 'our-legal-entity', id: legalEntityId }]
    }),
    addOurLegalEntityData: builder.mutation<LegalEntityOurDataDto, LegalEntityOurDataCreateDto & LegalEntityLink>({
      query: ({ legalEntityId, ...dto }) => ({
        url: `${LEGAL_ENTITY_BASE_URL}/our-legal-entity-data/${legalEntityId}`,
        method: 'POST',
        body: dto
      }),
      invalidatesTags: (result, error, query) => [{ type: 'our-legal-entity', id: query.legalEntityId }],
      async onQueryStarted({ legalEntityId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          invalidateEntityAudit(dispatch, AuditEntityType.LEGAL_ENTITY, legalEntityId);
        } catch (error) {
          console.error(error);
        }
      },
    }),
    updateOurLegalEntityData: builder.mutation<LegalEntityOurDataDto, LegalEntityOurDataUpdateDto & LegalEntityLink>({
      query: ({ legalEntityId, ...dto }) => ({
        url: `${LEGAL_ENTITY_BASE_URL}/our-legal-entity-data/${legalEntityId}`,
        method: 'PUT',
        body: dto
      }),
      invalidatesTags: (result, error, query) => [{ type: 'our-legal-entity', id: query.legalEntityId }],
      async onQueryStarted({ legalEntityId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          invalidateEntityAudit(dispatch, AuditEntityType.LEGAL_ENTITY, legalEntityId);
        } catch (error) {
          console.error(error);
        }
      },
    })
  })
});
